import { Navigate, Outlet, useNavigate } from "react-router";
import { useNative } from "../../shared/phone/media";
import { PortalTopBar } from "./PortalTopBar";
import { PortalFooter } from "./PortalFooter";
import { NativeFrame } from "./phone/Frame";
import { usePartnerAuth } from "../context/PartnerAuthContext";

/**
 * The portal frame: top bar, an optional re-sign bar, the routed workspace view,
 * and the footer. The inner app needs a selected program; without one it sends
 * the partner back to the programs picker rather than showing an empty shell.
 * On a phone and an iPad it is the native frame instead, and Home carries the
 * re-sign notice.
 */
export function PortalShell() {
  const { currentMembership, refresh } = usePartnerAuth();
  const navigate = useNavigate();
  const native = useNative();

  if (!currentMembership) return <Navigate to="/programs" replace />;

  if (native) {
    return (
      <NativeFrame nav onRefresh={() => void refresh().catch(() => {})}>
        <Outlet />
      </NativeFrame>
    );
  }

  return (
    <div className="portal">
      <PortalTopBar />
      {currentMembership.needsResign && (
        <div className="resign-bar">
          <span className="rb-ic">!</span>
          <span>
            {currentMembership.productName} updated the partner terms. Re-sign to keep your link
            active.
          </span>
          <button
            type="button"
            className="btn sm"
            style={{ marginLeft: "auto" }}
            onClick={() => navigate(`/onboarding/${currentMembership.programId}`)}
          >
            Review and re-sign
          </button>
        </div>
      )}
      <main className="main">
        <Outlet />
      </main>
      <PortalFooter />
    </div>
  );
}
